export const environmentName = (): string =>
  process.env.REACT_APP_ENVIRONMENT_NAME ?? "development";

export const isProduction = (): boolean => environmentName() === "production";

export const isDevelopment = (): boolean => environmentName() === "development";
